var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1091 818",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg804681524_3901_clip0_31_8641)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg804681524_3901_clip1_31_8641)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 136.624,
    x2: 136.624,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.069,
    x2: 182.069,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.513,
    x2: 227.513,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.957,
    x2: 272.957,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.402,
    x2: 318.402,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.846,
    x2: 363.846,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.291,
    x2: 409.291,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.735,
    x2: 454.735,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.18,
    x2: 500.18,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 545.624,
    x2: 545.624,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.069,
    x2: 591.069,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.513,
    x2: 636.513,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 681.957,
    x2: 681.957,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 727.402,
    x2: 727.402,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 772.846,
    x2: 772.846,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 818.291,
    x2: 818.291,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 863.735,
    x2: 863.735,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 909.18,
    x2: 909.18,
    y2: 818,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg804681524_3901_clip2_31_8641)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 45.1604,
    x2: 1090.67,
    y2: 45.1604,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 90.6049,
    x2: 1090.67,
    y2: 90.6049,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 136.049,
    x2: 1090.67,
    y2: 136.049,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 181.494,
    x2: 1090.67,
    y2: 181.494,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 226.938,
    x2: 1090.67,
    y2: 226.938,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 272.383,
    x2: 1090.67,
    y2: 272.383,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 317.827,
    x2: 1090.67,
    y2: 317.827,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 363.272,
    x2: 1090.67,
    y2: 363.272,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 408.716,
    x2: 1090.67,
    y2: 408.716,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 454.161,
    x2: 1090.67,
    y2: 454.161,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 499.605,
    x2: 1090.67,
    y2: 499.605,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 545.049,
    x2: 1090.67,
    y2: 545.049,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 590.494,
    x2: 1090.67,
    y2: 590.494,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 635.938,
    x2: 1090.67,
    y2: 635.938,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 681.383,
    x2: 1090.67,
    y2: 681.383,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 726.827,
    x2: 1090.67,
    y2: 726.827,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.00671387,
    y1: 772.272,
    x2: 1090.67,
    y2: 772.272,
    stroke: "#D0D5DD",
    strokeWidth: 0.568056
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg804681524_3901_clip0_31_8641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090.67,
    height: 818,
    fill: "white",
    transform: "translate(0.00671387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg804681524_3901_clip1_31_8641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090.67,
    height: 818,
    fill: "white",
    transform: "translate(0.00671387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg804681524_3901_clip2_31_8641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1090.67,
    height: 818,
    fill: "white",
    transform: "translate(0.00671387)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBg);
export default __webpack_public_path__ + "static/media/squareBg.b014423df78ddddba0a7fbdb4739cb30.svg";
export { ForwardRef as ReactComponent };